<div class="modal" id="riderAttendance" tabindex="-1">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
      <div class="modal-body p-0">
        <div class="container-fluid p-0 bg-light-gray">
          <div class="row row-cols-1 gy-2 m-0">
            <div class="col mt-0 navbar-spacer">
              <app-navbar
                class="fixed-top"
                [isShowBackButton]="true"
                [preventDefaultGoBack]="true"
                (goBackCallback)="hide()"
                [inputTitle]="'app.navbar.volunteerAttendance'"
              />
            </div>
            <div class="col bg-primary-white">
              <div class="row row-cols-2 m-0 py-3">
                <div class="col text-secondary mb-3">
                  {{ 'app.volunteerAttendance.name' | translate }}
                </div>
                <div class="col text-secondary mb-3">
                  {{ 'app.volunteerAttendance.attendance' | translate }}
                </div>
                @for (rider of riders; track $index) {
                  @let r = rider.rider;
                  <div class="col">
                    <div>{{ r.name?.enName }}</div>
                    <div>{{ r.name?.cnName }}</div>
                  </div>
                  <div class="col">
                    <div class="btn-toolbar gap-2">
                      <div class="flex-fill">
                        <input
                          [formControl]="rider.isAttendanceControl"
                          [attr.disabled]="isAttendanceSet(rider) || null"
                          type="radio"
                          class="btn-check"
                          name="atteRadio{{ $index }}"
                          id="atteRadioPresent{{ $index }}"
                          value="present"
                        />
                        <label
                          [class.btn-primary]="
                            rider.isAttendanceControl.value === 'present'
                          "
                          class="btn btn-secondary rounded-pill py-0 px-4 w-100"
                          for="atteRadioPresent{{ $index }}"
                          >{{
                            'app.volunteerAttendance.present' | translate
                          }}</label
                        >
                      </div>
                      <div class="flex-fill">
                        <input
                          [formControl]="rider.isAttendanceControl"
                          [attr.disabled]="isAttendanceSet(rider) || null"
                          type="radio"
                          class="btn-check"
                          name="atteRadio{{ $index }}"
                          id="atteRadioAbsent{{ $index }}"
                          value="absent"
                        />
                        <label
                          [class.btn-primary]="
                            rider.isAttendanceControl.value === 'absent'
                          "
                          class="btn btn-secondary rounded-pill py-0 px-4 w-100"
                          for="atteRadioAbsent{{ $index }}"
                          >{{ 'app.volunteerAttendance.absent' | translate }}</label
                        >
                      </div>
                      <div class="flex-fill">
                        <input
                          [formControl]="rider.isAttendanceControl"
                          [attr.disabled]="isAttendanceSet(rider) || null"
                          type="radio"
                          class="btn-check"
                          name="atteRadio{{ $index }}"
                          id="atteRadioLate{{ $index }}"
                          value="late"
                        />
                        <label
                          [class.btn-primary]="
                            rider.isAttendanceControl.value === 'late'
                          "
                          class="btn btn-secondary rounded-pill py-0 px-4 w-100"
                          for="atteRadioLate{{ $index }}"
                          >{{ 'app.volunteerAttendance.late' | translate }}</label
                        >
                      </div>
                      <div class="flex-fill">
                        <input
                          [formControl]="rider.isAttendanceControl"
                          [attr.disabled]="isAttendanceSet(rider) || null"
                          type="radio"
                          class="btn-check"
                          name="atteRadio{{ $index }}"
                          id="atteRadioExcused{{ $index }}"
                          value="excused"
                        />
                        <label
                          [class.btn-primary]="
                            rider.isAttendanceControl.value === 'excused'
                          "
                          class="btn btn-secondary rounded-pill py-0 px-4 w-100"
                          for="atteRadioExcused{{ $index }}"
                          >{{ 'app.volunteerAttendance.excused' | translate }}</label
                        >
                      </div>
                    </div>
                  </div>
                  @if (!$last) {
                    <div class="col-12 border-top my-3"></div>
                  }
                } @empty {
                  <div class="col-12 ratio ratio-1x1">
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      @if (isLoading) {
                        <div
                          class="spinner-border text-secondary-purple"
                        ></div>
                      } @else {
                        <div>
                          {{ 'app.volunteerAttendance.noVolunteer' | translate }}
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="col bg-primary-white" style="padding-top: 20px;">
              <div class="container px-4 pb-4">
                <button
                  class="btn btn-primary w-100"
                  (click)="updateRiderAttendance()"
                  [disabled]="disableUpdate()"
                >
                  {{ 'app.volunteerAttendance.confirm' | translate }}
                  @if (isUpdating) {
                    <div
                      class="spinner-border spinner-border-sm text-light"
                    ></div>
                  }
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
